import NavigationEnum from 'common/navigation';
import { queryClient } from 'common/repositories/query-client';
import Stack from 'components/commons/stack';
import Text from 'components/commons/text';
import { ShippingStorageSaver } from 'modules/shipping/components/shipping-form-storage-saver';
import { useRouter } from 'next/router';
import * as React from 'react';
import { CSS } from 'styles';
import typography from 'styles/typography';

interface TimerPaymentProps {
  expiredAt: Date;
  finishText?: string;
  startText?: string;
  css?: CSS;
}

export default function Countdown(props: TimerPaymentProps) {
  const { expiredAt, css } = props;
  const secondStart = Math.floor(new Date().getTime() / 1000);
  const secondEnd = Math.floor(expiredAt.getTime() / 1000);
  const [secondState, setSecond] = React.useState(secondEnd - secondStart);
  const { pathname, query, isReady } = useRouter();

  const bookingId = query.id as string;
  React.useEffect(() => {
    if (!isReady) return;
    if (secondState <= 0) {
      ShippingStorageSaver.removeAll();
      return;
    }

    const interval = setTimeout(() => {
      setSecond(() => {
        if (secondState === 0) {
          if (pathname === NavigationEnum.shippingDetail) {
            ShippingStorageSaver.removeAll();
            queryClient.refetchQueries({
              queryKey: ['getBookingForm', bookingId],
            });
          }
          return 0;
        }
        return secondState - 1;
      });
    }, 1000);

    return () => clearTimeout(interval);
  }, [bookingId, isReady, pathname, secondState]);

  return (
    <Stack.Item
      direction="horizontal"
      wrap
      justify="center"
      alignItems="center"
      grow
      css={css}
    >
      {secondState > 0 ? (
        <>
          <Text
            variant="body4"
            css={{ '@md': typography.body3 }}
            align="center"
          >
            {props.startText}
          </Text>
          <Text
            variant="headline6"
            weight="bold"
            css={{
              ml: 8,
              '@md': { ...typography.headline5, fontWeight: 'bold' },
            }}
          >
            {`${Math.floor(secondState / 3600)
              .toString()
              .padStart(2, '0')} : ${Math.floor((secondState / 60) % 60)
              .toString()
              .padStart(2, '0')} : ${Math.floor(secondState % 60)
              .toString()
              .padStart(2, '0')}`}
          </Text>
        </>
      ) : (
        <Text variant="body4" css={{ '@md': typography.body3 }} align="center">
          {props.finishText}
        </Text>
      )}
    </Stack.Item>
  );
}
